import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const MemoDetailHeader = ({ memo, page, save }) => (
  <div className="ui top attached menu">
    <div className="item">
      <a href={`/memos?page=${page}`} className="ui icon back button">
        <i className="sidebar icon" /> Retour à la Liste
      </a>
    </div>
    <div className="header borderless item">
      {memo.title}
      {memo.obsolete && <div className="ui red horizontal label">Supprimé</div>}
    </div>
    <div className="right menu">
      <div className="item">
        <Link
          to="/chapters/new"
          className="ui right floated right labeled icon button"
        >
          <i className="add icon" />
          Ajouter un chapitre
        </Link>
      </div>
      <div className="item">
        <button className="ui right floated primary button" onClick={save}>
          Mettre à jour
        </button>
      </div>
    </div>
  </div>
);

MemoDetailHeader.propTypes = {
  memo: PropTypes.object.isRequired,
  page: PropTypes.string.isRequired,
  save: PropTypes.func.isRequired,
};

export default MemoDetailHeader;



// WEBPACK FOOTER //
// ./src/modules/memo/components/MemoDetailHeader.js